// extracted by mini-css-extract-plugin
module.exports = {"nudgeWrapper":"_2eW0T","nudgeContainer":"_3fo_B","nudgeText":"_2-hux"};